import { Backdrop, Box, CircularProgress, Typography, circularProgressClasses } from '@mui/material';
import { Theme, alpha } from '@mui/material/styles';

const backdropStyles = (theme: Theme) => ({
    zIndex: theme.zIndex.modal + 1000,
    backgroundColor: alpha(theme.palette.common.white, 0.5),
});

const backProgressStyles = (theme: Theme) => ({
    color: theme.palette.grey[100],
});

const progressStyles = (theme: Theme) => ({
    [`& .${circularProgressClasses.circle}`]: {
        strokeLinecap: 'round',
    },
    color: theme.palette.primary.main,
    position: 'absolute',
    left: 0,
});

interface Props {
    text?: string;
    isHiddenText?: boolean;
}

export const BackdropLoader = ({ text = 'Loading...', isHiddenText }: Props) => {
    return (
        <Backdrop sx={backdropStyles} open>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="space-between">
                <Box position="relative">
                    <CircularProgress
                        variant="determinate"
                        size={44}
                        thickness={6}
                        value={100}
                        sx={backProgressStyles}
                    />
                    <CircularProgress sx={progressStyles} size={44} thickness={6} disableShrink />
                </Box>
                {!isHiddenText && <Typography>{text}</Typography>}
            </Box>
        </Backdrop>
    );
};
